export default __webpack_public_path__ + "static/media/486.e97b5991.jpg";